import React, { useState, useEffect } from "react";

import { useAttributionBacklink } from "icons/AttributionBacklink/Context";
import SpeechBubble from "core/SpeechBubble";

import { SpeechBubbleContainer } from "./styles";

const ThankYouSpeechBubble = ({ children }) => {
    const [showSpeechBubble, setShowSpeechBubble] = useState(false);

    const {
        runningThankYouAnimation,
        finishThankYouAnimation
    } = useAttributionBacklink();

    useEffect(() => {
        if (runningThankYouAnimation) {
            setTimeout(() => {
                setShowSpeechBubble(true);

                setTimeout(() => {
                    setShowSpeechBubble(false);
                    finishThankYouAnimation(false);
                }, 4000);
            }, 1200);
        }
    }, [runningThankYouAnimation]);

    return (
        <SpeechBubbleContainer>
            {children}
            <SpeechBubble show={showSpeechBubble}>Thanks!</SpeechBubble>
        </SpeechBubbleContainer>
    );
};

export default ThankYouSpeechBubble;
